import { useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { StyledIssuesListContainer } from './styled/IssuesList.styled';
import { Opportunity, OpportunityListQuery, OpportunityListResponse } from './queries/opportunity-list.queries.types';

import { GetOpportunityList } from './queries/opportunity-list.queries';

import OpportunitiesListHeader from './components/OpportunitiesListHeader';
import OpportunitiesListFilterBar from './components/OpportunitiesListFilterBar';
import OpportunitiesListTable from './components/OpportunitiesListTable';
import GraphQlErrorBoundary from 'components/layout/ErrorBoundary';
import Loading from 'components/layout/Loading';
import { ApolloError } from 'apollo-client';
import { ObservationStatusEnum } from 'shared/enums/ObservationStatus.enum';

export const OpportunitiesList = () => {
   const client = useApolloClient();
   const [loading, setLoading] = useState<boolean>(true);
   const [loadingError, setLoadingError] = useState<ApolloError>();
   const [filterDataLoaded, setFilterDataLoaded] = useState<boolean>(false);

   const [showFilterBar, setShowFilterBar] = useState<boolean>(false);

   const defaultFilter: OpportunityListQuery = {
      dateFrom: undefined,
      dateTo: undefined,
      observationCategoryId: [],
      observationStatus: [ObservationStatusEnum.Open, ObservationStatusEnum.Closed],
      depotPcId: [],
      divisionId: [],
      regionId: [],
      sHEQManagerId: []
   };

   const [issueRequest, setIssueRequest] = useState<OpportunityListQuery>(defaultFilter);
   const [issueData, setIssueData] = useState<Opportunity[]>();

   const toggleFilterBar = () => {
      setShowFilterBar(!showFilterBar);
   };

   useEffect(() => {
      loadIssueData();
   }, [issueRequest]);

   const resetIssueData = () => {
      setIssueRequest(defaultFilter);
   };

   const loadIssueData = async () => {
      setLoading(true);

      try {
         let result = await client.query<OpportunityListResponse>({
            query: GetOpportunityList,
            variables: {
               request: issueRequest
            },
            fetchPolicy: 'network-only'
         });

         if (result?.data?.opportunityRecords != null) {
            setIssueData(result.data.opportunityRecords);
         } else {
            setIssueData(undefined);
         }

         result?.data?.opportunityRecords.forEach(data => {
            if (data.offSiteLocation != null) {
               data.offSiteLocationDescription = data.offSiteLocation.locationDescription;
               data.offSiteLocationCustomerSite = data.offSiteLocation.customerSiteName;
            } else {
               data.offSiteLocationDescription = ' ';
               data.offSiteLocationCustomerSite = ' ';
            }

            if (data.depotPcName == null) {
               data.depotPcName = ' ';
            }
         });

         if (filterDataLoaded === false) {
            setFilterDataLoaded(true);
         }
      } catch (e: any) {
         setLoadingError(e);
      } finally {
         setLoading(false);
      }
   };

   return (
      <StyledIssuesListContainer>
         <OpportunitiesListHeader toggleFilterBar={toggleFilterBar} />
         <OpportunitiesListFilterBar
            showFilterBar={showFilterBar}
            toggleFilterBar={toggleFilterBar}
            data={issueData}
            filterDataLoaded={filterDataLoaded}
            filterRequest={issueRequest}
            setFilterRequest={setIssueRequest}
            resetFilter={resetIssueData}
         />

         <GraphQlErrorBoundary error={loadingError}>
            <Loading isLoading={loading} message={"Loading Opportunities Reports..."}>
               <OpportunitiesListTable data={issueData} />
            </Loading>
         </GraphQlErrorBoundary>
      </StyledIssuesListContainer>
   );
};
